var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:`form-control ${_vm.additionalClass}`,attrs:{"id":_vm.id,"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.debounceInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }